import configPropertiesJson from '../data/config-properties.json';
import type { ConfigProperties, ConfigPropertyEntry } from '../types/showcase';

/**
 * useConfigProperties — queue #665 §UAT-2026-07-09-R665 §R665-3.
 *
 * `data/config-properties.json`(apps/web/scripts/extract-config-metadata.mjs 가 빌드타임에
 * 생성) 을 정적 import 해 artifact 단위 설정 속성 목록을 조회한다. 런타임 fetch 가 없으므로
 * 별도 로딩 상태가 없다(§R665-3 5상태: loading = "정적 import=상태 없음").
 */
const CONFIG_PROPERTIES_DATA = configPropertiesJson as unknown as ConfigProperties;

/**
 * artifact 의 설정 속성 목록을 조회하는 순수 파생 함수. `data` 는 테스트에서 fixture 로
 * 교체할 수 있도록 선택 인자로 받는다(기본값 = 실제 빌드타임 데이터). 잘못된 shape(§R665-3
 * "error" 상태 — 파싱 방어)는 빈 배열로 fallback 한다.
 */
export function configPropertiesFor(
  artifact: string,
  data: ConfigProperties = CONFIG_PROPERTIES_DATA
): ConfigPropertyEntry[] {
  try {
    const properties = data?.modules?.[artifact]?.properties;
    return Array.isArray(properties) ? properties : [];
  } catch {
    return [];
  }
}

/** 컴포넌트에서 사용하는 훅 형태 — 정적 데이터이므로 즉시 반환(별도 로딩 상태 없음). */
export function useConfigProperties(artifact: string): ConfigPropertyEntry[] {
  return configPropertiesFor(artifact);
}
